import axios from 'axios';
import authHeader from './AuthHeaderService'

const API_TARIF_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PROD_URL + '/api/tarif' : 'http://localhost:8080/api/tarif';
const API_DEVIS_URL = process.env.NODE_ENV === "production" ? process.env.REACT_APP_PROD_URL + '/api/devis' : 'http://localhost:8080/api/devis';

class ApiService {

    fetchOffres(risque) {
        console.log(process.env.REACT_APP_PROD_URL);
        console.log(process.env.NODE_ENV);
        console.log(API_TARIF_URL);
        return axios.post(API_TARIF_URL + "/offres", risque)
    }

    fetchDevis() {
        console.log(process.env.REACT_APP_PROD_URL);
        console.log(process.env.NODE_ENV);
        console.log(API_DEVIS_URL);
        return axios.get(API_DEVIS_URL, { headers: authHeader() })
    }

    initializeDevis(risque) {
        console.log(process.env.REACT_APP_PROD_URL);
        console.log(process.env.NODE_ENV);
        console.log(API_DEVIS_URL);
        return axios.post(API_DEVIS_URL + "/nouveau", risque)
    }

    saveDevis(idDevis) {
        let devis = {
            idDevis : idDevis
        };
        console.log(process.env.REACT_APP_PROD_URL);
        console.log(process.env.NODE_ENV);
        console.log(API_DEVIS_URL);
        return axios.put(API_DEVIS_URL + '/sauvegarder/' + idDevis, devis,{ headers: authHeader() })
    }

    fetchPrimeByGarUsage(usage, gar,va) {
        if (va)
            return axios.get(API_TARIF_URL + '/prime/' + usage + '/' + gar + '/' + va);
        else
            return axios.get(API_TARIF_URL + '/prime/' + usage + '/' + gar + '/0');

    }
    
}

export default new ApiService();